import { render, staticRenderFns } from "./getcertificateforreportprint.vue?vue&type=template&id=3035054a&scoped=true&"
import script from "./getcertificateforreportprint.vue?vue&type=script&lang=js&"
export * from "./getcertificateforreportprint.vue?vue&type=script&lang=js&"
import style0 from "./getcertificateforreportprint.vue?vue&type=style&index=0&id=3035054a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035054a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VRow,VSnackbar})
